(function () {
  function prepare() {
    var sectionWrappers = Array.prototype.slice.call(
      document.querySelectorAll('main > [id^="shopify-section-"]')
    );

    sectionWrappers.forEach(function (el, i) {
      if (i === 0) return; // skip the first section (already visible on load)
      if (el.querySelector('.product-card')) return; // cards animate individually instead
      if (el.querySelector('.shop-links-section')) return; // hero overlay must always be visible
      el.setAttribute('data-reveal', '');
    });

    // On the home page on phones, the first row of products (the top two) loads right away with no fade,
    // so it's already there when you scroll down. Everything after that appears as you scroll.
    var preloadCount =
      document.body.classList.contains('is-home') && window.matchMedia('(max-width: 749px)').matches ? 2 : 0;

    var cards = document.querySelectorAll('.product-card');
    cards.forEach(function (el, i) {
      if (i < preloadCount) {
        el.querySelectorAll('img').forEach(function (img) {
          img.loading = 'eager';
          img.setAttribute('fetchpriority', 'high');
        });
        return;
      }
      el.setAttribute('data-reveal', '');
      el.style.transitionDelay = Math.min((i - preloadCount) % 4, 3) * 0.04 + 's';
    });
  }

  function observe() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length || !('IntersectionObserver' in window)) return;

    // An item is revealed once its top edge has scrolled a little way (about 7% of the screen) up from the
    // bottom of the screen. Measuring from the edge, not from a share of the item's area, keeps tall sections
    // from waiting far too long.
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0, rootMargin: '0px 0px -7% 0px' }
    );

    els.forEach(function (el) {
      io.observe(el);
    });
  }

  function init() {
    prepare();
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();